import { doAttention } from '@/attention';
export function shakeY(el, duration = undefined, options = {}) {
    return doAttention(el, 'shakeY', duration, options);
}
//# sourceMappingURL=shakeY.js.map